import type { SVGProps } from 'react'
const LineStar = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M6.49 21.59c-.26 0-.515-.08-.735-.24-.39-.28-.58-.75-.5-1.225l.94-5.49L2.21 10.75a1.23 1.23 0 0 1-.315-1.28c.15-.455.535-.78 1.01-.85l5.51-.8 2.465-4.99c.21-.43.64-.695 1.12-.695s.91.265 1.12.695l2.465 4.99 5.51.8a1.247 1.247 0 0 1 .695 2.13l-3.985 3.885.94 5.485a1.25 1.25 0 0 1-1.815 1.32L12 18.85l-4.93 2.59a1.3 1.3 0 0 1-.585.145zM12 17.16l5.18 2.72-.99-5.765 4.19-4.085-5.79-.84L12 3.945 9.41 9.19l-5.79.84 4.19 4.085-.99 5.765z"
		/>
	</svg>
)
export { LineStar }
